// extracted by mini-css-extract-plugin
module.exports = {"techSnapshot-section":"elements_techSnapshot-section__16fk5","techSnapshot-decorative":"elements_techSnapshot-decorative__3Al8W"};